import { render, staticRenderFns } from "./AddNewCompanyModal.vue?vue&type=template&id=2b288388&"
import script from "./AddNewCompanyModal.vue?vue&type=script&lang=js&"
export * from "./AddNewCompanyModal.vue?vue&type=script&lang=js&"
import style1 from "./AddNewCompanyModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports